import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PostComponent implements OnInit {
  // post:{id:number};
  post;
  activeReplyFormId :number;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.post = this.route.snapshot.params['id'];
    // console.log('this.post',this.post);
  }

  replyToComment(commentId){
    this.activeReplyFormId = commentId;
  }

  cancelReply(){
    this.activeReplyFormId = null;
  }
  
  blogs = [
    {
      'slug':'tips-and-tricks-to-use-solar-power-equipment-with-ease',
      'title':'Tips and tricks to use solar power equipment with ease',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'commentId':0,
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
          'replys':[
            {
              'replyBy':'Anand Ahuja',
              'replyOn':'June 20, 2017',
              'reply':'It is dummy text of the printing and typesetting industry.'
            },
            {
              'replyBy':'Om Raut',
              'replyOn':'August 9, 2017',
              'reply':'It is dummy text of the printing and typesetting industry.'
            }
          ]
        },
        {
          'commentId':1,
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    },
    {
      'slug':'blog-title-1',
      'title':'Blog Title 1',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    },
    {
      'slug':'blog-title-2',
      'title':'Blog Title 2',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    },
    {
      'slug':'blog-title-3',
      'title':'Blog Title 3',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    }
  ];
}
